import Vue from 'vue';

Vue.prototype.$isMobile = function() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
    ? true
    : false;
};

declare module 'vue/types/vue' {
  interface Vue {
    $isMobile: any;
  }
}
